import * as React from "react";
import { ArrowNarrow } from "../../../assets/svg/ArrowNarrow";
import { SvgContainer } from "../svg-container/SvgContainer";
export var ProductionTransitionArrow = function (_a) {
    var children = _a.children;
    return (React.createElement(SvgContainer, { name: "arrow-narrow", svg: ArrowNarrow }, children));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/generic/common/ProductionTransitionArrow.tsx
// module id = 582
// module chunks = 3